// extracted by mini-css-extract-plugin
module.exports = {"buttonExpand":"styles_buttonExpand__bXWOY"};